import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContactComponent } from "./contact/contact.component";
import { HelpComponent } from "./help/help.component";
import { SharedModule } from "../shared.module";

const componentList = [ContactComponent, HelpComponent];

@NgModule({
  declarations: [componentList],
  imports: [CommonModule, SharedModule],
  exports: [componentList],
})
export class HelpModule {}
